// extracted by mini-css-extract-plugin
export default {"wrapper":"g7-z"};